export const primaryButtonSx = {
    height: 52,
    background: '#1976D2',
    color: '#FFFFFF',
    letterSpacing: '0.04em',
    '&:hover': { background: '#1868B7' },
};
export const secondaryButtonSx = {
    height: 52,
    background: 'transparent',
    boxShadow: 'none',
    color: '#899295',
    '&:hover': { background: '#2B2E30', boxShadow: 'none' },
};
export const codeInputSx = {
    height: 52,
    fontSize: 20,
    letterSpacing: '0.08em',
    color: '#292C2E',
    '& fieldset': { border: 0 },
};
